import { convertDimensions } from '../../../../services/unit-services/dimensions/dimension-convert-service';
import { convertWeight } from '../../../../services/unit-services/weights/weight-convert-service';

export const initialState = (presetGroupData, sellerDefaults) => {
  const {
    weightUnitOfMeasureId = 'Unknown',
    weight: originalWeight = null,
    dimensionUnitOfMeasureId = 'Unknown',
    length: originalLength = 0,
    width: originalWidth = 0,
    height: originalHeight = 0,
  } = presetGroupData;

  const { sellerDimUnit, sellerWeightUnit } = sellerDefaults;

  const convertedDimensions = convertDimensions(
    {
      length: originalLength,
      width: originalWidth,
      height: originalHeight,
      unit: dimensionUnitOfMeasureId,
    },
    sellerDimUnit,
  );
  const { length, width, height } = convertedDimensions;

  let weight = originalWeight;
  if (weightUnitOfMeasureId.toLowerCase() !== sellerWeightUnit.toLowerCase()) {
    const convertedWeight = convertWeight({ value: originalWeight, unit: weightUnitOfMeasureId }, sellerWeightUnit);
    weight = convertedWeight?.value;
  }

  return {
    ...presetGroupData,
    weight,
    length,
    width,
    height,
  };
};

export const presetGroupReducer = (state, action) => {
  switch (action.type) {
    case 'set': {
      return {
        ...state,
        [action.fieldName]: action.payload,
      };
    }
    case 'setBulk': {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
